<template>
  <Modal
    :show="show"
    width="366"
    cancel-text=""
    action-text=""
    @close="handleClose"
  >
    <template #title>
      <span class="text-h2">Rename {{ nodeLabel }}</span>
    </template>
    <template #content>
      <p class="text-body-1 text-textDarkest mb-4">
        Change the name of this {{ nodeLabel.toLowerCase() }}.
      </p>
      <v-text-field
        v-model="name"
        :placeholder="currentName"
        variant="outlined"
        density="compact"
        rounded="lg"
        color="primary"
        :error="Boolean(nameError)"
        :error-messages="nameError"
        class="rename-job-family-field mt-4 mb-14"
      />
    </template>
    <template #actions>
      <DpplNewButton
        class="bulk-modal-action text-button-1"
        variant="flat"
        color="primary"
        :disabled="!canUpdate"
        :loading="loading"
        @click="handleConfirm"
      >
        Update
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { getArchitectureNameError } from '@/helpers/jobProfileSettingsValidation';

const props = defineProps({
  show: { type: Boolean, default: false },
  currentName: { type: String, default: '' },
  nodeLabel: { type: String, default: 'Job Family' },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);

const name = ref('');

const trimmedName = computed(() => name.value.trim());

const nameError = computed(() => getArchitectureNameError(name.value, [], ''));

const canUpdate = computed(() => (
  Boolean(trimmedName.value)
  && trimmedName.value.toLowerCase() !== (props.currentName || '').toLowerCase()
  && !nameError.value
));

const reset = () => {
  name.value = '';
};

const handleClose = () => {
  reset();
  emit('close');
};

const handleConfirm = () => {
  if (!canUpdate.value) {
    return;
  }

  emit('confirm', trimmedName.value);
};

watch(() => props.show, (isOpen) => {
  if (!isOpen) {
    reset();
  }
});
</script>

<style scoped lang="less">
.bulk-modal-action {
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}

.rename-job-family-field {
  :deep(.v-field__input) {
    font-size: 13px;
  }

  :deep(.v-field__input::placeholder) {
    color: @text-lighter;
    opacity: 1;
  }
}
</style>
